import { Signal } from "@/data/util/Signal";

import { BaseController } from "@/app/controller/BaseController";

export class RoomPlanController extends BaseController {
    public onContinue?: { () };
    public onShowServices?: { () };

    static onInit = new Signal();
    static onShown = new Signal();
    static onHidden = new Signal();

    static onContinue = new Signal();
    static onShowServices = new Signal();

    constructor() {
        super("room-plan");

        RoomPlanController.onContinue.add(this.continue, this);
        RoomPlanController.onShowServices.add(this.showServices, this);

        RoomPlanController.onInit.dispatch();
    }

    protected onBecomeVisible() {
        RoomPlanController.onShown.dispatch();
    }

    protected onBecomeInvisible() {
        RoomPlanController.onHidden.dispatch();
    }

    protected showServices() {
        if (this.onShowServices) {
            this.onShowServices();
        }
    }

    protected continue() {
        if (this.onContinue) {
            this.onContinue();
        }
    }
}
